import { IMenuItem } from '@/interfaces';

export const CONSTANTS = {
  PROJECT_TITLE: 'DAWN',
  META: {
    TITLE: 'Dawn: Diabetes and wellness program.',
    DESCRIPTION: 'Supporting your diabetes management by improving your mental health.',
  },
  CONTACT_EMAIL: 'info@parentsandteens.org.au',
  LOGO: {
    PATH: '/images/logo.svg',
  },
  MENU: {
    PUBLIC: [
      { id: 'about', label: 'About', href: '/about' },
      { id: 'exercises', label: 'Exercises', href: '/exercise' },
      { id: 'fact-sheets', label: 'Fact sheets', href: '/fact-sheets' },
      { id: 'contact', label: 'Contact', href: '/contact' },
    ] as IMenuItem[],
    PRIVATE: [
      { id: 'dashboard', label: 'Dashboard', href: '/console' },
      { id: 'exercises', label: 'Exercises', href: '/exercise' },
      { id: 'fact-sheets', label: 'Fact sheets', href: '/fact-sheets' },
      { id: 'contact', label: 'Contact', href: '/contact' },
    ] as IMenuItem[],
  },
  GROUPS: {
    CODES: {
      PARTICIPANT: {
        ID: '614S'
      }
    }
  },
  USERFLOW: {
    MODULES: {
      URL: 'modules',
    },
    EXERCISE_TOOLBOX: {
      ID: 103,
      URL: 'exercise-toolbox',
      STEPS: {
        MINDFULNESS_LEAVES: {
          ID: 426,
          URL: 'mindfulnessleavesonariver',
        },
        AFFIRMATION: {
          ID: 427,
          URL: 'affirmation',
        },
        BODY_SCAN_MEDITIATION: {
          ID: 428,
          URL: 'bodyscanmeditation',
        },
        SCHEDULE_WORRY_TIME: {
          ID: 429,
          URL: 'scheduleworrytime',
          PAGE_URL_TO_ID_MAP: {
             'schedule-worry-time': 130041 
          }
        },
        MOTIVATIONAL_TAKEAWAY: {
          ID: 430,
          URL: 'motivation-takeaway',
        },
        BOX_BREATHING: {
          ID: 431,
          URL: 'box-breathing-1',
        },
        JOURNAL_PROMPT: {
          ID: 432,
          URL: 'journal-prompt',
          PAGE_URL_TO_ID_MAP: {
            'journal-prompt-form': 130074,
          },
        },
        GRATITUDE_PROMPT: {
          ID: 433,
          URL: 'gratitude-prompt',
          PAGE_URL_TO_ID_MAP: {
            'gratitude-prompt-form': 130076,
          },
        },
        LIFE_MAP: {
          ID: 435,
          URL: 'life-map',
          PAGE_URL_TO_ID_MAP: {
            'life-map-step-1': 130077,
            'life-map-step-2': 130078,
            'life-map-step-3': 130079,
            'life-map-step-4': 130080,
          },
        },
        GOAL_SETTING: {
          ID: 448,
          URL: 'goal-setting',
          PAGE_URL_TO_ID_MAP: {
            'goal-setting-step-1': 130139,
            'goal-setting-step-2': 130140,
            'goal-setting-step-3': 130141,
            'goal-setting-step-4': 130142,
            'goal-setting-step-5': 130143,
          },
        },
        NAMING_EMOTIONS: {
          ID: 450,
          URL: 'naming-emotions',
          PAGE_URL_TO_ID_MAP: {
            'naming-emotions-step-1': 130169,
            'naming-emotions-step-2': 130170,
            'naming-emotions-step-3': 130172,
            'naming-emotions-step-4': 130173,
            'naming-emotions-step-5': 130175,
            'naming-emotions-final': 130176,
          },
        },
        VALUES_COMPASS: {
          ID: 454,
          URL: 'valuescompass',
          PAGE_URL_TO_ID_MAP: {
            'values-compass-step-1': 130226,
            'values-compass-step-2': 130227,
            'values-compass-step-3': 130228,
          },
        },
      },
    },
  },
  URLS: {
    ABOUT: {
      id: 'about',
      label: 'About',
      href: '/about',
    },
    PRIVACY: {
      id: 'privacy',
      label: 'Privacy Policy',
      href: '/privacy-policy',
    },
    TERMS: {
      id: 'terms-and-conditions',
      label: 'Terms & conditions',
      href: '/terms-and-conditions',
    },
    FAQ: {
      id: 'faq',
      label: 'FAQ',
      href: '/faq',
    },
    CONTACT: {
      id: 'contact',
      label: 'Contact',
      href: '/contact',
    },
  } satisfies { [key: string]: IMenuItem },
  COOKIES: {
    MODULE_COMPLETE: 'module-completion',
    GOAL_COMPLETE: 'goal-completion',
    SPOTLIGHT: 'shouldShowSpotlight',
    PHONE_NUMBER: 'phoneNumber',
  },
  DIRECTORY: {
    HELP_AND_SUPPORT: {
      ID: 49,
    },
    SUPPORT_SERVICES: {
      ID: 52,
      KEY: 'support-services',
    },
    FACT_SHEETS: {
      ID: 59, // TODO: set correct directory type ID from CMS
    },
    FOR_CLINICIANS: {
      ID: 60, // TODO: set correct directory type ID from CMS
    },
  },
  STATIC_PAGE_REGENERATION_TIME_IN_SECONDS: 60,
};
